


































































import Config, { Mode } from "@/models/config.model";
import Translations from '@/models/translations.model';
import FilterGroup from '@/models/filter-group.model';
import PredefinedFilterItem from '@/models/predefined-filter-item.model';
import FilterGroupFilterCombi from '@/classes/filter-group-filter-combi.model';

export default {
  name: "FilterBar",
  data() {
    return {
      sortBy: this.$store.state.config.initialSorting,
      productsShop: this.$store.state.productsShopCheckbox,
      bookmarkCount: 0,
    };
  },
  computed: {
    isFilterMode(): boolean {
      return this.config.mode === Mode.Filter;
    },
    productSorting(): string {
      return this.$store.state.productSorting;
    },
    productCount(): number {
      return this.$store.getters.filteredProducts.length;
    },
    productsShopCount(): number {
      return this.$store.state.productsShop.length;
    },
    productsRentalCount(): number {
      return this.$store.state.productsRental.length;
    },
    filteredProductsShopCount(): number {
      const productsShop = this.$store.state.productsShop;
      const filteredProducts = this.$store.getters.filteredProducts;
      const filteredProductShop = productsShop.map((p: { matNo: string; }) => {
        return filteredProducts.filter((fp: { matNo: string; }) => fp.matNo === p.matNo);
      }).filter((p: string|null) => {
        return p != null && p != '';
      });

      return filteredProductShop.length;
    },
    filteredProductsRentalCount(): number {
      const productsRental = this.$store.state.productsRental;
      const filteredProducts = this.$store.getters.filteredProducts;
      const filteredProductRental = productsRental.map((p: { matNo: string; }) => {
        return filteredProducts.filter((fp: { matNo: string; }) => fp.matNo === p.matNo);
      }).filter((p: string|null) => {
        return p != null && p != '';
      });

      return filteredProductRental.length;
    },
    filterOnlineAvailable(): number {
      return this.$store.state.filters.filter((f: any) => f.id === 'onlineAvailable').length
    },
    filterRentable(): number {
      return this.$store.state.filters.filter((f: any) => f.id === 'rentable').length
    },
    config(): Config {
      return this.$store.state.config;
    },
    isMatnoMode(): boolean {
      return this.config.mode === Mode.Matno;
    },
    isMatnoReducedMode(): boolean {
      return this.config.mode === Mode.MatnoReduced;
    },
    translations(): Translations {
      return this.$store.state.translations;
    },
    filters(): Array<FilterGroup> {
      return this.$store.state.filters;
    },
    predefinedFilterItems(): Array<PredefinedFilterItem> {
      return this.$store.state.predefinedFilterItems;
    },
    selectedFilters(): Array<FilterGroupFilterCombi> {
      return this.$store.state.selectedFilters;
    },
    resultsFiltered(): string {
      return this.translations.resultsFiltered
        .replace("{PRODUCTS_COUNT}", this.productCount)
        .replace("{RESULTS}", this.productCount === 1 ? this.translations.result : this.translations.results);
    },
    filterCount(): number {
      const predefinedFilterItemsCount = this.predefinedFilterItems ? this.predefinedFilterItems.length : 0;
      const selectedFiltersCount = this.selectedFilters ? this.selectedFilters.length : 0;
      return predefinedFilterItemsCount + selectedFiltersCount;
    },
  },
  watch: {
    productSorting() {
      if (this.sortBy !== this.productSorting) {
        this.sortBy = this.productSorting;
      }
    },
    selectedFilters() {
      const productListing = (this.$el as HTMLElement).closest<HTMLElement>('.mdl-product-listing');
      
      if (!productListing || productListing.offsetTop > window.scrollY) {
        return;
      }

      productListing.scrollIntoView();
    }
  },
  methods: {
    async bindWishlistChangeListener() {
        const wishlist = await window.Miele.Wishlist.ready();

        this.bookmarkCount = wishlist.getCount();

        wishlist.onChange(() => {
          this.bookmarkCount = wishlist.getCount();
        });
    },
    moveFilterToFilterBar(checkbox: string, filter: string) {
      const filterCheckbox = document.querySelector(checkbox);
      const productListingFilter = document.querySelector(filter);
    
      if(!filterCheckbox || !productListingFilter)
        return;
      
      const fltGroup2col = filterCheckbox?.closest('.flt-group-2col');
      productListingFilter.prepend(filterCheckbox);
      fltGroup2col?.remove();
    },
    /**
     * Handles the change-event
     * of the sortBy-select
     * and emits the 'sort-change' event
     **/
    handleSortChange() {
      this.$emit("sort-change", this.sortBy);
    },
    handleFilterButtonClick() {
      const productFilterApp = (this.$el as HTMLElement).closest('#product-filter-app');

      if (!productFilterApp) {
        return;
      }

      let offcanvasFlyoutScroll: HTMLElement | null;

      if (window.matchMedia('(min-width: 768px)').matches) {
        offcanvasFlyoutScroll = productFilterApp.querySelector('.obj-offcanvas__flyout-scroll');
      } else {
        offcanvasFlyoutScroll = productFilterApp.querySelector('.obj-offcanvas__flyout');
      }
      
      if (!offcanvasFlyoutScroll) {
        return;
      }

      offcanvasFlyoutScroll.scrollTo(0, 0);
    },
  },
  mounted() {
    this.bindWishlistChangeListener();
    this.moveFilterToFilterBar('.flt-checkbox--isrentable', '.mdl-product-listing__filter-rental');
    this.moveFilterToFilterBar('.flt-checkbox--isonline', '.mdl-product-listing__filter-shop');
  },
};
